<template>
  <div id="ctcTemplate">
    <div>
      <navHeader></navHeader>
    </div>
    <router-view />
  </div>
</template>

<script>
  import navHeader from "@/components/navigation/navHeader.vue";
  export default {
    name: 'CTCTemplate',
    components: {
      navHeader
    },
  }
</script>
